/**
 * Inline controls for the writing screen. Icons rather than labels: on a phone
 * these sit inside a coloured half alongside the text being written, and two
 * words of chrome per field would crowd out the thing that matters.
 *
 * Both are drawn, matching the chilis, faces and side markers.
 */

/** Random — crossing arrows. Reads as "give me a different one", not "roll". */
export const ShuffleIcon = ({ size = 22, color }: { size?: number; color: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" fill="none">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7h4.5l7 10H18" />
      <path d="M3 17h4.5l7-10H18" />
      <path d="M15.5 14.5L18.5 17l-3 2.5" />
      <path d="M15.5 4.5L18.5 7l-3 2.5" />
    </g>
  </svg>
);

/** Clear — a cross. Anything cleverer reads as "close" rather than "empty". */
export const ClearIcon = ({ size = 22, color }: { size?: number; color: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M6.5 6.5l11 11M17.5 6.5l-11 11"
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

/**
 * Chevron — steps the avatar carousel. Drawn as a single stroke at the same
 * weight as the others, so it sits beside the faces rather than competing.
 */
export const ChevronIcon = ({
  size = 22,
  color,
  direction,
}: {
  size?: number;
  color: string;
  direction: "left" | "right";
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" fill="none">
    <path
      d={direction === "left" ? "M15 5 L8 12 L15 19" : "M9 5 L16 12 L9 19"}
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Settings — cogwheel. Lucide "settings", MIT-licensed. */
export const SettingsIcon = ({ size = 22, color }: { size?: number; color: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" fill="none">
    <path
      d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2" />
  </svg>
);
